(() => {
  if (customElements.get('featured-products-grid')) {
    return;
  }

  class FeaturedProductsGrid extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
      this.mobileBreakpoint = '(max-width: 767px)';
    }

    connectedCallback() {
      this.initSlider();

      this.attachEvents();
    }

    disconnectedCallback() {
      if (this.slider) {
        this.slider.destroy();
      }
    }

    attachEvents() {
      this.debouncedOnResize = debounce(() => {
        const isMobileDevices = window.matchMedia(
          this.mobileBreakpoint,
        ).matches;

        if (isMobileDevices && this.slider) {
          return;
        }

        if (!isMobileDevices && this.slider) {
          this.destroySlider();

          return;
        }

        this.initSlider();
      }, 100);

      window.addEventListener('resize', this.debouncedOnResize.bind(this));
    }

    initSlider() {
      const enableMobileSlider = this.hasAttribute('data-enable-mobile-slider');
      const isMobileDevices = window.matchMedia(this.mobileBreakpoint).matches;

      if (!this.querySelector('[data-slider]') || !isMobileDevices || !enableMobileSlider) {
        return;
      };

      this.options = {
        slidesPerView: 'auto',
        spaceBetween: 20
      };

      if (this.hasAttribute('data-autoplay')) {
        this.options.autoplay = {
          delay: this.dataset.autoplaySpeed,
        };
      }

      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }

    destroySlider() {
      this.slider.destroy();

      this.slider = null;
    }
  }

  customElements.define('featured-products-grid', FeaturedProductsGrid);
})();
